import { PaginationResult } from '@pristine-ts/aws';
import { array } from '@pristine-ts/data-mapping-common';
import { property } from '@pristine-ts/metadata';

export class ListResultResponse<T> {
  @array((target: any, propertyKey: string, index: number) => {
    return {};
  })
  items: T[] = [];

  @property()
  paginationResult?: PaginationResult;
}